module.exports = __webpack_public_path__ + "static/media/preloader.870ff929.gif";